import React from "react"
import { Text } from "@chakra-ui/react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import { asMoney } from "utilities/strings"
import * as Yup from "yup"
import { addSmsCredits } from "api/events"
import RadioBoxes from "./RadioBoxes"

type Props = {
  onHide: () => void
  eventId: string
  amountOptions: {
    amount: string
    label: string
  }[]
  selectedCreditPackageAmount: string
  setSelectedCreditPackageAmount: (amount: string) => void
}

const validationSchema = Yup.object().shape({
  amount: Yup.string().required(),
})

const BuyTextMessageCreditsModal = ({
  onHide,
  eventId,
  amountOptions,
  selectedCreditPackageAmount,
  setSelectedCreditPackageAmount,
}: Props) => {
  const handleSubmit = async () => {
    const { data } = await addSmsCredits(eventId, Number(selectedCreditPackageAmount))
    window.location.href = data.url
  }

  return (
    <ModalForm
      title="Message Credits"
      onClose={onHide}
      onSubmit={handleSubmit}
      submitText={`Pay ${asMoney(selectedCreditPackageAmount, "USD")}`}
      initialValues={{ amount: selectedCreditPackageAmount }}
      validationSchema={validationSchema}
      size="md"
    >
      {({ control }) => (
        <>
          <Text>Buy message credits to use across all events in your account.</Text>
          <RadioBoxes options={amountOptions} control={control} name="amount" onChange={(amount) => setSelectedCreditPackageAmount(amount)} />
        </>
      )}
    </ModalForm>
  )
}

export default BuyTextMessageCreditsModal
